import { useTranslation } from "react-i18next";

const IMAGES = {
  DAG2: "https://kr.object.gov-ncloudstorage.com/kerc-kquake-public/web/images/etc/waveform_approximation_DAG2.png",
  MKL: "https://kr.object.gov-ncloudstorage.com/kerc-kquake-public/web/images/etc/waveform_approximation_MKL.png",
  PHA2: "https://kr.object.gov-ncloudstorage.com/kerc-kquake-public/web/images/etc/waveform_approximation_PHA2.png",
  ULJ2: "https://kr.object.gov-ncloudstorage.com/kerc-kquake-public/web/images/etc/waveform_approximation_ULJ2.png",
};

export const WaveformApproximation = () => {
  const { t } = useTranslation();
  return (
    <div className="container">
      <div className="sub-container">
        <div style={{ fontSize: "15px", marginBottom: "5px" }}>
          &nbsp;&nbsp;<i className="ion ion-md-help-circle-outline"></i>
          {t("page.waveform-approximation.desc")}
        </div>
        <div className="overflow-auto">
          {Object.keys(IMAGES).map((sourceStation) => (
            <>
              <img
                src={IMAGES[sourceStation]}
                alt="Seismic Design Category Map"
                style={{ maxWidth: "100%" }}
                title={t("page.waveform-approximation.imgTitle", {
                  sourceStation,
                })}
              />
              <div style={{ textAlign: "center", marginBottom: 30 }}>
                {"<" +
                  t("page.waveform-approximation.imgTitle", {
                    sourceStation,
                  }) +
                  ">"}
              </div>
            </>
          ))}
        </div>
      </div>
    </div>
  );
};
